import { HttpErrorResponse } from '@angular/common/http';

export class InvalidListEditResponseException extends Error {
  constructor(
    public response: HttpErrorResponse,
    message = 'Invalid List Edit response',
  ) {
    super(message);
  }
}
